/*
 * Purpose: Route/page mount wrapper — ui-motion-page-enter with reduced-motion safe CSS
 * Last modified: 2026-06-27 | Agent
 * Completeness: 95
 */
import { cn } from '@/lib/utils';
import { motionClasses } from '@/motion';

interface PageMotionProps {
  children: React.ReactNode;
  className?: string;
  /** Split header/body timing for hero layouts */
  variant?: 'page' | 'header' | 'body';
}

export function PageMotion({ children, className, variant = 'page' }: PageMotionProps) {
  const motionClass =
    variant === 'header'
      ? motionClasses.pageEnterHeader
      : variant === 'body'
        ? motionClasses.pageEnterBody
        : motionClasses.pageEnter;

  return <div className={cn(motionClass, className)}>{children}</div>;
}
